'use strict';

import 'document-register-element';
import {isTouch} from '../utils';

const HTML = document.documentElement;
const TOUCH = isTouch();

class Select extends HTMLLabelElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._opened = false;
    this._selected = 0;
    if (TOUCH) this.classList.add('mobile');

    this._onUpdateArray = [];

    this._f_toggle = e => this._toggle(e);
    this._f_change = e => this._change(e);
    this._f_docClick = e => this._docClick(e);
    this._f_docKeyDown = e => this._docKeyDown(e);
    this._f_set = e => this._setFull(e);
  }
  connectedCallback() {
    this._select = this.querySelector('.selectElement');
    this._options = this._select.querySelectorAll('option');
    this._label = this.querySelector('.selectLabel');
    this._fakeOptions = this.querySelectorAll('.selectOption');

    this._length = this._select.length;


    if (!this._fakeOptions.length) {
      this._f_change = e => this._singleChange(e);
      this._f_set = e => this._set(e);
    }

    this._label.addEventListener('click', this._f_toggle);
    this._select.addEventListener('change', this._f_change);

    for (let i = 0; this._fakeOptions.length > i; i++) {
      if (this._fakeOptions[i].classList.contains('selected')) this._selected = i;
      this._fakeOptions[i].addEventListener('click', this._click.bind(this, i))
    }

    HTML.addEventListener('click', this._f_docClick, true);
    HTML.addEventListener('keydown', this._f_docKeyDown, true);
  }
  disconnectedCallback() {

  }
  _open() {
    this.classList.add('active');
    this._opened = true;
  }
  _close() {
    this.classList.remove('active');
    this._opened = false;
  }
  _toggle() {
    if (this._opened) {
      this._close();
    } else {
      this._open();
    }
  }
  _change() {
    this._setFull(this._select.selectedIndex);
  }
  _singleChange() {
    this._label.innerHTML = this._select.selectedOptions[0].innerHTML;

    this._selected = this._select.selectedIndex;

    for (let i = 0; this._onUpdateArray.length > i; i++) {
      this._onUpdateArray[i](this._select.selectedIndex, this._select.options[this._selected].value);
    }
  }
  _click(i) {
    this._setFull(i);
    this._close();
  }
  _setFull(i) {
    if (i === this._selected) return;

    this._options[i].selected = true;

    // this.dispatchEvent(new Event('change'));

    let event = document.createEvent('HTMLEvents');
    event.initEvent('change', true, false);
    this.dispatchEvent(event);


    if (!isNaN(this._selected)) this._fakeOptions[this._selected].classList.remove('selected');

    this._fakeOptions[i].classList.add('selected');

    this._label.innerHTML = this._fakeOptions[i].innerHTML;

    this._selected = i;

    for (let i = 0; this._onUpdateArray.length > i; i++) {
      this._onUpdateArray[i](this._selected, this._select.options[this._selected].value);
    }
  }
  _set(i) {
    if (i === this._selected) return;
    this._selected = i;
    this._label.innerHTML = this._select.options[i].innerHTML;
  }
  _docClick(e) {
    if (this.contains(e.target)) return;
    if (this._opened) {
      this._close();
    }
  }
  _docKeyDown(e) {
    if (e.keyCode !== 27) return;
    if (this._opened) {
      this._close();
    }
  }

  set selected(number) {
    if (number > this._length - 1) return;

    this._f_set(number);
  }
  set value (value) {
    this._select.value = value;

    this._setFull(this._select.selectedIndex);
  }
  set onUpdate(func) {
    this._onUpdateArray.push(func);
    func(this._selected, this._select.options[this._selected].value);
  }
}

window.customElements.define('view-select', Select, {extends: 'label'});
